// Where this device came from, sent once at signup (dashboard/js/api.js) and
// cleaned by backend/signup/arrival.py. Two records, each
// {v: path, r: referring host, u: utm_source, o: "www" | "app", t}:
//
//   ghd_entry       the first page opened, kept 90 days and never replaced inside them;
//   ghd_last_touch  the latest load that came from another site or carries
//                   ?utm_source=, replaced by each newer one.
//
// From the URL only the path and utm_source: any other parameter can carry an ad id.
// AI apps often send no Referer but ChatGPT appends ?utm_source=chatgpt.com, so
// either one identifies the source.
//
// Runs on both origins. On the app (<html data-origin="app">, which survives the
// build folding this file into app-bundle.js where a tag attribute would not) it covers a
// visitor who opens the app without passing www; www's own records arrive later
// through site/go/, and app.js keeps the earlier entry and the later last touch.
// Keys are spelled out, as in head-init.js; GHD.KEYS is the registry of record.
(function () {
  // Hosts that are a step in our own flows, never a source: our origins and the
  // TWA, and the sign-in and payment pages that send people back to us.
  var NOT_A_SOURCE =
    /(^|\.)(gethumandesign\.com|supabase\.co|stripe\.com|paypal\.com|localhost)$|^(accounts\.google\.com|appleid\.apple\.com|127\.0\.0\.1|com\.gethumandesign\.app)$/;
  var origin;
  var touch;
  var external;
  try {
    origin = document.documentElement.getAttribute("data-origin") === "app" ? "app" : "www";
    var ref = "";
    try {
      ref = document.referrer ? new URL(document.referrer).hostname.toLowerCase() : "";
    } catch (e) {}
    var ours = !!ref && NOT_A_SOURCE.test(ref);
    // On the app, a hop from www, a sign-in return or an email link is a step
    // in a journey that started elsewhere, not an arrival.
    if (
      origin === "app" &&
      (ours ||
        location.hash.indexOf("#ghd_handoff=") === 0 ||
        /(^|[?&])(code|token_hash|error)=/.test(location.search.slice(1)) ||
        /access_token=/.test(location.hash))
    )
      return;
    var utm = String(new URLSearchParams(location.search).get("utm_source") || "")
      .trim()
      .toLowerCase();
    if (!/^[a-z0-9][a-z0-9._-]{0,63}$/.test(utm)) utm = "";
    external = (!!ref && !ours) || !!utm;
    touch = JSON.stringify({ v: location.pathname, r: ref, u: utm, o: origin, t: Date.now() });
  } catch (e) {
    return;
  }
  try {
    var entry = null;
    try {
      entry = JSON.parse(localStorage.getItem("ghd_entry") || "null");
    } catch (e) {}
    if (!entry || !(Date.now() - entry.t < 90 * 24 * 3600 * 1000)) localStorage.setItem("ghd_entry", touch);
  } catch (e) {}
  try {
    if (external) localStorage.setItem("ghd_last_touch", touch);
  } catch (e) {}
})();
